// {#Edit: Create new entry for your list}
// Note: Each list must have one entry here
//       Sort your entry by Name Ascending
const QUERIES = {
  EXAMPLE_LIST: 'example-list',

  MAINTENANCE_USER_LIST: 'maintenance-user-list',
  MAINTENANCE_CATEGORY_LIST: 'maintenance-category-list',
  MEMBERS_LIST: 'members-list',
  PARTNERS_LIST: 'partners-list',
  SUBMISSION_LIST: 'submission-list',
  DIRECTORY_MEMBERS_LIST: 'directory-members-list',
  DIRECTORY_PARTNERS_LIST: 'directory-partners-list',
}

export {QUERIES}
